import { createSlice } from "@reduxjs/toolkit";

const intialTeamsState = {
  allTeams: [],
  teams: [],
  totalTeams: 0,
  loading: false,
  team: [],
  totalMembers: 0,
  teamLoading: false,
};

const teams = createSlice({
  name: "teams",
  initialState: intialTeamsState,
  reducers: {
    getTeamsSaga(state) {
      state.loading = true;
    },
    getTeams(state, action) {
      state.teams = action.payload.teams;
      state.totalTeams = action.payload.totalTeams;
      state.loading = false;
      if (action.payload.allTeams) state.allTeams = action.payload.allTeams;
    },
    getTeamsFail(state) {
      state.loading = false;
    },
    getTeamSaga(state) {
      state.teamLoading = true;
    },
    getTeam(state, action) {
      state.team = action.payload.data;
      state.totalMembers = action.payload.totalMembers;
      state.teamLoading = false;
    },
    getTeamFail(state) {
      state.teamLoading = false;
    },
  },
});
export const teamsAction = teams.actions;
export default teams.reducer;
